import Vue from 'vue'
import {ifElementExistsThenLaunch} from './functions/dom';
import {alertsController} from './alerts-controller';
import {w} from './cltvo/constants';
// import {applicationSelectContainer}from './application-select-container';
import {navside}	from './navside';
import {positionHeader} from './menu-fixed';
import {front} from './vue/main/front';
import {cart} from './vue/main/cart';
import {checkout} from './vue/main/checkout';
import {billing} from './vue/main/billing';

import {singleApplicationVue} from './vue/main/single-application';
import {setsApplicationVue} from './vue/main/sets-application';
import {mainVue} from './vue/main-vue';
import {applicationSlide} from './vue/components/general/application-slide';
import MenuCart from './vue/components/menu-cart.vue';

import {
	addressModalCreate,
	addressModalEdit,
	address,
} from './vue/components/general/simple-cruds-client';

Vue.component('menu-cart', MenuCart)


w.on('load', () => {

	ifElementExistsThenLaunch([
		['#main-vue', mainVue, undefined, [front, {}]],
		['#cart-vue', mainVue, undefined, [cart, {}]],
		['#checkout-vue', mainVue, undefined, [checkout, {}]],
		['#billing-vue', mainVue, undefined, [billing, {}]],
		['#front-vue', mainVue, undefined, [front, {
			addressModalCreate,
			addressModalEdit,
			address,
			applicationSlide,
		}]],
		['#single-application-vue', mainVue, undefined, [singleApplicationVue, {}]],
		['#sets-application-vue', mainVue, undefined, [setsApplicationVue, {}]],
		['#alert__container', alertsController, 'init', []],
	]);

	navside();
	positionHeader()
});

//cosas relacionaDropdas únicamente con la version de desarrollo
if (process.env.NODE_ENV ==='webpack') { window.CLTVO_ENV = 'webpack'} //corre en modo webpack, necesario para hacer HMR
if (module.hot) { module.hot.accept(); }//permite hacer Hot Module Replacement
